import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle, Transition } from "@headlessui/react";
function Modal(t0) {
  const $ = _c(18);
  const {
    afterEnter,
    isOpen,
    onClose,
    title,
    children,
    fullScreen
  } = t0;
  let t1;
  if ($[0] !== afterEnter || $[1] !== isOpen) {
    t1 = <Transition afterEnter={afterEnter} show={isOpen} />;
    $[0] = afterEnter;
    $[1] = isOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogBackdrop transition={true} className="fixed inset-0 bg-zinc-950/30 opacity-100 transition-opacity duration-200 motion-reduce:transition-none motion-reduce:data-[closed]:opacity-100 data-[closed]:opacity-0 dark:bg-zinc-950/70" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `fixed inset-0 flex items-center justify-center p-4 ${fullScreen ? "h-[var(--vvh)]" : ""}`;
  const t4 = `flex max-h-[calc(var(--vvh)-2rem)] w-full max-w-sm scale-100 flex-col rounded-lg bg-white opacity-100 shadow-lg transition-[transform,opacity] duration-150 motion-reduce:transition-none motion-reduce:data-[closed]:scale-100 motion-reduce:data-[closed]:opacity-100 data-[closed]:scale-95 data-[closed]:opacity-0 dark:bg-zinc-800 dark:shadow-none ${fullScreen ? "h-lvh" : ""}`;
  let t5;
  if ($[4] !== title) {
    t5 = <DialogTitle className="mb-3 px-[20px] pt-5 text-xl font-semibold">{title}</DialogTitle>;
    $[4] = title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== t4 || $[8] !== t5) {
    t6 = <DialogPanel transition={true} className={t4}>{t5}{children}</DialogPanel>;
    $[6] = children;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <div className={t3}>{t6}</div>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isOpen || $[14] !== onClose || $[15] !== t1 || $[16] !== t7) {
    t8 = <Dialog as="div" className="absolute z-30" onClose={onClose} open={isOpen} transition={true}>{t1}{t2}{t7}</Dialog>;
    $[13] = isOpen;
    $[14] = onClose;
    $[15] = t1;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
export default Modal;